import Vue from "vue";

import "./ngVueDirectives";
import ngVueComponentsModule from "./ngVueComponentsModule";
import "vue-cal/dist/drag-and-drop";
import "vue-cal/dist/i18n/fr";

// @ts-ignore
import VCalendar from "v-calendar";

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

// @ts-ignore
import VueMasonry from "vue-masonry-css";
import UserUtils from "./utils/UserUtils";
import ConfirmSuppression from "./core/Modals/ConfirmSuppression";

Vue.use(VueMasonry);

// PortalVue
import PortalVue from "portal-vue";

Vue.use(PortalVue);

// Custom properties for Vue components
UserUtils.isAdmin().then((isAdmin) => (Vue.prototype.$isAdmin = isAdmin));
// Hors connexion (page de login), le profil est refusé : le rejet est déjà
// signalé par l'appel précédent.
UserUtils.hasWebAccess().then(
    (hasWebAccess) => (Vue.prototype.$hasWebAccess = hasWebAccess),
    () => {}
);

// Saisie de la raison d'une suppression (corbeille), pour les écrans
// AngularJS qui n'ont pas accès aux modules du bundle Vue.
(window as any).ConfirmSuppression = ConfirmSuppression;

// @ts-ignore
angular.module("ngVueApp", [ngVueComponentsModule.name]);
